export const FRAMEWORKS = [
  {
    id:           'cmmc_l1',
    name:         'CMMC Level 1',
    shortName:    'CMMC L1',
    description:  'Foundational cybersecurity practices for protecting Federal Contract Information (FCI) across 6 domains.',
    controlCount: 17,
    category:     'defense',
    color:        '#4CAF50',
    available:    true,
  },
  {
    id:           'cmmc_l2',
    name:         'CMMC Level 2',
    shortName:    'CMMC L2',
    description:  'Advanced practices aligning with all 110 NIST SP 800-171 requirements for protecting Controlled Unclassified Information (CUI).',
    controlCount: 110,
    category:     'defense',
    color:        '#2D7DD2',
    available:    true,
  },
  {
    id:           'cmmc_l3',
    name:         'CMMC Level 3',
    shortName:    'CMMC L3',
    description:  'Expert practices based on NIST SP 800-172 for organizations supporting critical defense programs against advanced persistent threats.',
    controlCount: 130,
    category:     'defense',
    color:        '#7C3AED',
    available:    true,
  },
  {
    id:           'nist_171',
    name:         'NIST SP 800-171',
    shortName:    'NIST 171',
    description:  'The 110 NIST SP 800-171 requirements for protecting CUI in non-federal systems, independent of CMMC compliance.',
    controlCount: 110,
    category:     'defense',
    color:        '#1565C0',
    available:    true,
  },
  {
    id:           'soc2',
    name:         'SOC 2 Type II',
    shortName:    'SOC 2',
    description:  'AICPA trust services criteria covering security, availability, processing integrity, confidentiality, and privacy for service organizations.',
    controlCount: 64,
    category:     'commercial',
    color:        '#F59E0B',
    available:    true,
  },
  {
    id:           'iso27001',
    name:         'ISO 27001',
    shortName:    'ISO 27001',
    description:  'International standard specifying requirements for establishing, implementing, and maintaining an information security management system.',
    controlCount: 93,
    category:     'commercial',
    color:        '#EC4899',
    available:    true,
  },
  {
    id:           'hipaa',
    name:         'HIPAA Security Rule',
    shortName:    'HIPAA',
    description:  'Federal standards protecting electronic protected health information through administrative, physical, and technical safeguards.',
    controlCount: 69,
    category:     'healthcare',
    color:        '#06B6D4',
    available:    true,
  },
  {
    id:           'nist_csf',
    name:         'NIST CSF 2.0',
    shortName:    'CSF 2.0',
    description:  'The updated NIST Cybersecurity Framework providing voluntary guidance organized around six core functions: Govern, Identify, Protect, Detect, Respond, Recover.',
    controlCount: 106,
    category:     'commercial',
    color:        '#64748B',
    available:    true,
  },
  {
    id:           'pci_dss',
    name:         'PCI DSS v4.0',
    shortName:    'PCI DSS',
    description:  'Payment Card Industry Data Security Standard requirements for organizations that store, process, or transmit cardholder data.',
    controlCount: 285,
    category:     'finance',
    color:        '#EF4444',
    available:    true,
  },
  {
    id:           'fedramp',
    name:         'FedRAMP Moderate',
    shortName:    'FedRAMP',
    description:  'Government-wide program providing a standardized approach to security assessment for cloud products and services used by federal agencies.',
    controlCount: 325,
    category:     'defense',
    color:        '#3730A3',
    available:    true,
  },
];

export function getFrameworkById(id) {
  return FRAMEWORKS.find(f => f.id === id) || FRAMEWORKS[1]; // default cmmc_l2
}
